import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_FOR_PROVIDER } from "src/api-setup/api-endpoints";

export const getForProvider = async (cookiesData, dispatch) => {
  if (!cookiesData) return [];

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_user_id: cookiesData?.out_user_id,
      in_tenant_id: cookiesData?.out_tenant_id || "",
    };

    const response = await POSTAPI(false, GET_FOR_PROVIDER, null, apiHeaders, requestBody, dispatch);

    if (response && response.data && response.data.row_result) {
      return response?.data.row_result;
    }

    return [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
